 import moment from 'moment';

 export const convertUnixToUTC = (unixTimestamp) => {
        return moment.unix(unixTimestamp).utc().format('DD/MM/YY');
    };